
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        kds: Number,
        name: String,
    }
});
